import App from '@/app/app.vue';
import Vue from 'vue';
import VueMq from 'vue-mq';
import VueNotifications from 'vue-notification';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import Vuetable from 'vuetable-2'
import './shared';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueNotifications);
Vue.use(VueMq, {
  breakpoints: {
      phone: 576,
      tablet: 768,
      desktop: 992,
      lg: 1200,
  },
});
Vue.use(Vuetable)


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
